import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin, message } from 'antd';
import CandidateViewModal from '../../components/Candidates/CandidateViewModal';
import { fetchCandidateById, updateCandidate } from '../../redux/candidatesSlice';
import { fetchUsers } from '../../redux/userOrganisationsSlice';
import { fetchVacancies } from '../../redux/vacanciesSlice';

const CandidateDetailsPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { current: candidate, loading: candidateLoading } = useSelector((state) => state.candidates);
    const { list: users, loading: usersLoading } = useSelector((state) => state.userOrganisations);
    const { list: vacancies, loading: vacanciesLoading } = useSelector((state) => state.vacancies);
    const { orgId } = useSelector((state) => state.auth);

    const loading = candidateLoading || usersLoading || vacanciesLoading;

    useEffect(() => {
        if (!id) return;
        const load = async () => {
            try {
                await Promise.all([
                    dispatch(fetchCandidateById({ id: parseInt(id), organisationId: orgId })).unwrap(),
                    users?.length ? Promise.resolve() : dispatch(fetchUsers()).unwrap(),
                    vacancies?.length ? Promise.resolve() : dispatch(fetchVacancies({ skip: 0, limit: 50 })).unwrap()
                ]);
            } catch (e) {
                message.error('Не удалось загрузить кандидата');
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, dispatch, orgId]);

    const handleClose = useCallback(() => {
        navigate('/candidates');
    }, [navigate]);

    const handleCommentSubmit = useCallback(async (candidateId, comment) => {
        try {
            await dispatch(updateCandidate({ id: candidateId, organisationId: orgId, candidate: { comment } })).unwrap();
        } catch (e) {
            message.error('Ошибка при сохранении комментария');
        }
    }, [dispatch, orgId]);

    if (loading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!candidate) return null;

    return (
        <div style={{ padding: 24 }}>
            <CandidateViewModal
                visible={true}
                onClose={handleClose}
                onCommentSubmit={handleCommentSubmit}
                candidate={candidate}
                vacancies={vacancies}
                users={users}
                getFiles={(c) => c?.files || []}
            />
        </div>
    );
};

export default CandidateDetailsPage;


